export default __webpack_public_path__ + "69729e8d88d49a8ed34709149c2cf7fe.svg";